var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 10,
    viewBox: "0 0 19 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_786_51047)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 9.37109H1.5L8.08579 2.78531C8.86684 2.00426 10.1332 2.00426 10.9142 2.78531L17.5 9.37109H9.5Z",
    fill: "#292B2E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_786_51047"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 9,
    fill: "white",
    transform: "matrix(1 0 0 -1 0.5 9.37109)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBlack);
export default __webpack_public_path__ + "static/media/Arrow_black.3fb1e5b7c4ffd9f7181f2b88c5afee9a.svg";
export { ForwardRef as ReactComponent };